import React from 'react';
import ResultGlyphs from 'es6/components/apps/result-glyphs';

/**
 * Provides helper methods to look at presentation and session data for
 * correct/incorrect information.
 */
export const SentenceTrainerSummaryMixin = {
  propTypes: {
    presentationResults: React.PropTypes.array.isRequired,
    sessionData: React.PropTypes.object.isRequired,
  },

  /**
   * Creates an array of objects containing mistakes and hint count for each
   * sentence. As well as the corresponding result glyph. The resulting object
   * contains the keys: contentId, isCorrect, mistakes, hints, resultGlyph.
   *
   * @returns {Object[]}
   */
  _getSentenceTrainerResults() {
    // Group presentation results by content ID.
    const groupedByContentId = {};

    this.props.presentationResults.forEach(pr => {
      const contentId = pr.contentId;

      if (!groupedByContentId[contentId]) {
        groupedByContentId[contentId] = {
          contentId,
          isCorrect: pr.isCorrect(),
          hints: 0,
          mistakes: 0,
          resultGlyph: ResultGlyphs.CORRECT,
        };
      }

      const result = groupedByContentId[contentId];

      // Increment mistakes.
      if (!pr.isCorrect()) {
        result.mistakes++;
      }

      // Set isCorrect to the appropriate value.
      result.isCorrect = result.isCorrect || pr.isCorrect();

      // Use the highest number of hints used.
      const hintsUsed = pr.quizData.hintsUsed;
      if (hintsUsed) {
        result.hints = Math.max(result.hints, pr.quizData.hintsUsed);
      }

      // Get the approprate glyph.
      if (result.isCorrect && result.mistakes > 0) {
        result.resultGlyph = ResultGlyphs.CORRECT_WITH_MISTAKES;
      } else if (!result.isCorrect) {
        result.resultGlyph = ResultGlyphs.INCORRECT;
      }
    });

    return Object.keys(groupedByContentId).map(key => groupedByContentId[key]);
  },
};

export default SentenceTrainerSummaryMixin;
